import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ReleaseDataError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ReleaseDataError', ...args);
    }
}
export default ReleaseDataError;
